"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _util = require("./util");

var _helocCoDeedActions = require("../actions/heloc-co-deed-actions");

var _disclosureActions = require("../actions/disclosure-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  coIdentityUuidHelocStatus: {
    helocUuid: '',
    active: false,
    deedDocumentUuid: '',
    disclosurelistNotaryComplete: false,
    participantAcceptComplete: false,
    disclosureList: {
      uuid: '',
      applicationUuid: '',
      disclosures: []
    },
    propertyState: ''
  },
  coDeedsByHelocUuids: {// 'a6d3c3d4-369a-11e8-b467-0ed5f89f718b': {
    //   helocUuid: 'a6d3c3d4-369a-11e8-b467-0ed5f89f718b',
    //   coDeeds: [] // { uuid, name, address, econsent, idDocs, email, dob }
    // },
    // loading: false,
    // error: ''
  },
  helocCoDeedDisclosuresByUuid: {// [coDeedUuid]: {
    //   coDeedUuid: '',
    //   uuid: '',
    //   applicationUuid: '',
    //   disclosures: [
    //     {
    //       uuid: '',
    //       type: '',
    //       hasEsignature: false,
    //       document: {
    //         uuid: '',
    //         type: '',
    //         name: '',
    //         countryCode: '',
    //         description: ''
    //       },
    //       signedDocument: {
    //         uuid: '',
    //         type: '',
    //         name: '',
    //         countryCode: '',
    //         description: ''
    //       },
    //       signatureRequired: false,
    //     }
    //   ]
    // }
  },
  loading: false,
  error: ''
};
exports.initialState = initialState;

function merge(state, action) {
  var helocUuid = action.meta.helocUuid;
  var helocCoDeeds = state.coDeedsByHelocUuids[helocUuid] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    coDeedsByHelocUuids: _objectSpread(_objectSpread({}, state.coDeedsByHelocUuids), {}, (0, _defineProperty2.default)({}, helocUuid, _objectSpread(_objectSpread({}, helocCoDeeds), {}, {
      helocUuid: helocUuid,
      coDeeds: Array.isArray(action.payload) ? (0, _util.mergeList)(helocCoDeeds.coDeeds, action.payload) : (helocCoDeeds.coDeeds || []).map(function (c) {
        if (c.uuid === action.payload.uuid) {
          return _objectSpread(_objectSpread({}, c), {}, {
            name: _objectSpread(_objectSpread({}, c.name), {}, {
              firstName: action.payload.name.firstName,
              lastName: action.payload.name.lastName,
              suffix: action.payload.name.suffix
            }),
            address: action.payload.address,
            econsent: _objectSpread(_objectSpread({}, c.econsent || {}), {}, {
              uuid: action.payload.econsent.uuid,
              optStatus: action.payload.econsent.optStatus,
              type: action.payload.econsent.type,
              version: action.payload.econsent.version
            }),
            idDocs: (0, _util.mergeList)(c.idDocs, action.payload.idDocs),
            email: action.payload.email,
            dob: action.payload.dob
          });
        }

        return c;
      })
    }))),
    loading: false,
    error: ''
  });
}

var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_helocCoDeedActions.GET_HELOC_STATUS, "_").concat(_httpActions.REQUEST), "".concat(_helocCoDeedActions.GET_CO_DEEDS, "_").concat(_httpActions.REQUEST), "".concat(_helocCoDeedActions.GET_HELOC_CO_DEED_DISCLOSURES, "_").concat(_httpActions.REQUEST)), function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true,
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_helocCoDeedActions.GET_CO_DEEDS, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return merge(state, action);
}), (0, _defineProperty2.default)(_handleActions, "".concat(_helocCoDeedActions.GET_HELOC_CO_DEED_DISCLOSURES, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var coDeedUuid = action.meta.coDeedUuid;
  var coDeedDisclosures = state.helocCoDeedDisclosuresByUuid[coDeedUuid] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    helocCoDeedDisclosuresByUuid: _objectSpread(_objectSpread({}, state.helocCoDeedDisclosuresByUuid), {}, (0, _defineProperty2.default)({}, coDeedUuid, _objectSpread(_objectSpread({}, coDeedDisclosures), {}, {
      coDeedUuid: coDeedUuid,
      uuid: action.payload.uuid,
      applicationUuid: action.payload.applicationUuid,
      disclosures: (0, _util.mergeList)(coDeedDisclosures.disclosures, action.payload.disclosures)
    }))),
    loading: false
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_helocCoDeedActions.GET_HELOC_STATUS, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var _action$payload = action.payload,
      disclosureList = _action$payload.disclosureList,
      propertyState = _action$payload.propertyState;
  return _objectSpread(_objectSpread({}, state), {}, {
    coIdentityUuidHelocStatus: _objectSpread(_objectSpread({}, state.coIdentityUuidHelocStatus), {}, {
      helocUuid: action.payload.uuid,
      active: action.payload.active,
      deedDocumentUuid: action.payload.deedDocumentUuid,
      disclosurelistNotaryComplete: action.payload.disclosurelistNotaryComplete,
      participantAcceptComplete: action.payload.participantAcceptComplete,
      disclosureList: _objectSpread(_objectSpread({}, state.coIdentityUuidHelocStatus.disclosureList), {}, {
        uuid: disclosureList.uuid,
        applicationUuid: disclosureList.applicationUuid,
        disclosures: (0, _util.mergeList)(state.coIdentityUuidHelocStatus.disclosureList.disclosures, disclosureList.disclosures)
      }),
      propertyState: propertyState
    }),
    loading: false
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_helocCoDeedActions.SAVE_CONSENT, "_").concat(_httpActions.REQUEST), "".concat(_helocCoDeedActions.UPLOAD_DOCUMENT, "_").concat(_httpActions.REQUEST)), function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_helocCoDeedActions.SAVE_CONSENT, "_").concat(_httpActions.SUCCESS), "".concat(_helocCoDeedActions.UPLOAD_DOCUMENT, "_").concat(_httpActions.SUCCESS)), function (state, action) {
  return merge(state, action);
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_helocCoDeedActions.SAVE_CONSENT, "_").concat(_httpActions.FAILURE), "".concat(_helocCoDeedActions.UPLOAD_DOCUMENT, "_").concat(_httpActions.FAILURE)), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: (0, _util.payloadError)(action)
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_disclosureActions.ESIGN_DISCLOSURE, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  if (action.payload.msg) {
    return _objectSpread(_objectSpread({}, state), {}, {
      error: action.payload.msg
    });
  }

  var disclosures = state.coIdentityUuidHelocStatus.disclosureList.disclosures;
  var disclosure = disclosures.find(function (d) {
    return d.document.uuid === action.payload.referenceDocumentUuid;
  });

  if (!disclosure) {
    return _objectSpread(_objectSpread({}, state), {}, {
      error: "No disclosure with document ".concat(action.payload.documentUuid, " found")
    });
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    coIdentityUuidHelocStatus: _objectSpread(_objectSpread({}, state.coIdentityUuidHelocStatus), {}, {
      disclosureList: _objectSpread(_objectSpread({}, state.coIdentityUuidHelocStatus.disclosureList), {}, {
        disclosures: state.coIdentityUuidHelocStatus.disclosureList.disclosures.map(function (d) {
          if (d.document.uuid === disclosure.document.uuid) {
            return _objectSpread(_objectSpread({}, d), {}, {
              hasEsignature: d.hasEsignature || false || action.payload.succeeded
            });
          }

          return d;
        })
      })
    })
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;